import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const blogApi = createApi({
    reducerPath: 'blogApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_BASE_URL }),
    endpoints: builder => ({
        getAllBlogs: builder.query({
            query: () => `/api/blogs`,
        }),
        getBlogBySlug: builder.query({
            query: slug => `/api/blogs/${slug}`,
        }),
    }),
});

export const { useGetAllBlogsQuery, useGetBlogBySlugQuery } = blogApi;
